var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gif-selector-wrapper p-4"},[_c('div',{ref:"hypefuryGifSelector"}),(_vm.showGoBackButton)?_c('base-button',{staticClass:"button secondary-button small-button",attrs:{"disabled":_vm.isLoading},on:{"click":_vm.close}},[_vm._v("Go back")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }